import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { FileUpIcon } from "lucide-react"

const ExportButton = () => {

  return (
    <div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="default" className="[&_svg]:size-5">
            Export <FileUpIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
            <DropdownMenuItem
                  key={1}
                  className="capitalize"
                >
                  <span>Excel</span>
            </DropdownMenuItem>
            <DropdownMenuItem
                  key={1}
                  className="capitalize"
                >
                  <span>Word</span>
            </DropdownMenuItem>
            <DropdownMenuItem
                  key={1}
                  className="capitalize"
                >
                  <span>PDF</span>
            </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ExportButton;